/**
 * Web mock for react-native-html-to-pdf - not used on web (export uses print)
 */
module.exports = {
  generatePDF: () => Promise.resolve({ filePath: '' }),
};
